/* eslint-disable */
/* auto-generated angular directive proxies */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  NgZone,
} from '@angular/core';
import { ProxyCmp, proxyOutputs } from './angular-component-lib/utils';

import { Components } from '@cds.js/core';

export declare interface CdsAccordion extends Components.CdsAccordion {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['multi'],
})
@Component({
  selector: 'cds-accordion',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['multi'],
})
export class CdsAccordion {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsAccordionItem extends Components.CdsAccordionItem {
  /**
   * Emit event to notify accordion
   */
  cdsToggleAccordionItem: EventEmitter<CustomEvent<{ id: string; isOpen: boolean }>>;
}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['expanded'],
})
@Component({
  selector: 'cds-accordion-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['expanded'],
  outputs: ['cdsToggleAccordionItem'],
})
export class CdsAccordionItem {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsToggleAccordionItem']);
  }
}

export declare interface CdsAccordionItemContent extends Components.CdsAccordionItemContent {}

@ProxyCmp({
  defineCustomElementFn: undefined,
})
@Component({
  selector: 'cds-accordion-item-content',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
})
export class CdsAccordionItemContent {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsAccordionItemHeader extends Components.CdsAccordionItemHeader {
  /**
   * Emit event to notify accordion item
   */
  cdsToggleAccordionItemHeader: EventEmitter<CustomEvent<{ id: string; isOpen: boolean }>>;
}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['closeIcon', 'customizable', 'heading', 'icon', 'openIcon', 'reverse'],
})
@Component({
  selector: 'cds-accordion-item-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['closeIcon', 'customizable', 'heading', 'icon', 'openIcon', 'reverse'],
  outputs: ['cdsToggleAccordionItemHeader'],
})
export class CdsAccordionItemHeader {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsToggleAccordionItemHeader']);
  }
}

export declare interface CdsAlert extends Components.CdsAlert {
  /**
   * Triggers when confirm a close, if the isConfirmed value is `true` mean that user preset `Acept` button
   */
  cdsConfirmChanged: EventEmitter<CustomEvent<{ isConfirmed: boolean }>>;
}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: [
    'alertTitle',
    'cancelButtonText',
    'confirmButtonText',
    'html',
    'preventClose',
    'reverseButtons',
    'text',
    'timer',
    'type',
  ],
})
@Component({
  selector: 'cds-alert',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: [
    'alertTitle',
    'cancelButtonText',
    'confirmButtonText',
    'html',
    'preventClose',
    'reverseButtons',
    'text',
    'timer',
    'type',
  ],
  outputs: ['cdsConfirmChanged'],
})
export class CdsAlert {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsConfirmChanged']);
  }
}

export declare interface CdsBadge extends Components.CdsBadge {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['color', 'disabled', 'light'],
})
@Component({
  selector: 'cds-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['color', 'disabled', 'light'],
})
export class CdsBadge {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsButton extends Components.CdsButton {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: [
    'disabled',
    'endIcon',
    'href',
    'icon',
    'isRound',
    'onlyIcon',
    'size',
    'startIcon',
    'target',
    'type',
    'variant',
  ],
})
@Component({
  selector: 'cds-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: [
    'disabled',
    'endIcon',
    'href',
    'icon',
    'isRound',
    'onlyIcon',
    'size',
    'startIcon',
    'target',
    'type',
    'variant',
  ],
})
export class CdsButton {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsCard extends Components.CdsCard {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['padding', 'withShadow', 'xsTransparent'],
})
@Component({
  selector: 'cds-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['padding', 'withShadow', 'xsTransparent'],
})
export class CdsCard {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsCardHeader extends Components.CdsCardHeader {}
@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['align', 'xsAlign'],
})
@Component({
  selector: 'cds-card-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['align', 'xsAlign'],
})
export class CdsCardHeader {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsCardBody extends Components.CdsCardBody {}
@ProxyCmp({
  defineCustomElementFn: undefined,
})
@Component({
  selector: 'cds-card-body',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
})
export class CdsCardBody {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsCardFooter extends Components.CdsCardFooter {}
@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['align', 'xsAlign'],
})
@Component({
  selector: 'cds-card-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['align', 'xsAlign'],
})
export class CdsCardFooter {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

import type { CheckboxEvent as ICheckboxCheckboxEvent } from '@cds.js/core/dist/types/components/checkbox/checkbox-event.interface';
export declare interface CdsCheckbox extends Components.CdsCheckbox {
  /**
   * Emitted when the value has changed.
   */
  cdsChange: EventEmitter<CustomEvent<ICheckboxCheckboxEvent>>;
}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['checked', 'disabled', 'label', 'labelPosition', 'name', 'value', 'variant'],
})
@Component({
  selector: 'cds-checkbox',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['checked', 'disabled', 'label', 'labelPosition', 'name', 'value', 'variant'],
  outputs: ['cdsChange'],
})
export class CdsCheckbox {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsChange']);
  }
}

export declare interface CdsChip extends Components.CdsChip {
  /**
   * Emitted when the value has changed.
   */
  cdsClose: EventEmitter<CustomEvent<void>>;
}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['color', 'disabled', 'icon', 'isClose', 'size'],
})
@Component({
  selector: 'cds-chip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['color', 'disabled', 'icon', 'isClose', 'size'],
  outputs: ['cdsClose'],
})
export class CdsChip {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsClose']);
  }
}

export declare interface CdsCircularProgress extends Components.CdsCircularProgress {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['buffer', 'completedColor', 'progress'],
})
@Component({
  selector: 'cds-circular-progress',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['buffer', 'completedColor', 'progress'],
})
export class CdsCircularProgress {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsDropdown extends Components.CdsDropdown {
  /**
   * Emitted when the value has changed only if multiple is `false`
   */
  cdsChange: EventEmitter<CustomEvent<string>>;
  /**
   * Emitted when the value has changed only if multiple is `true`
   */
  cdsMultipleChange: EventEmitter<CustomEvent<Array<string>>>;
}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['disabled', 'label', 'multiple', 'placeholder', 'search', 'size', 'value'],
  methods: ['hide', 'show'],
})
@Component({
  selector: 'cds-dropdown',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['disabled', 'label', 'multiple', 'placeholder', 'search', 'size', 'value'],
  outputs: ['cdsChange', 'cdsMultipleChange'],
})
export class CdsDropdown {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsChange', 'cdsMultipleChange']);
  }
}

export declare interface CdsDropdownItem extends Components.CdsDropdownItem {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['disabled', 'label', 'selected', 'value'],
  methods: ['setMultiple'],
})
@Component({
  selector: 'cds-dropdown-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['disabled', 'label', 'selected', 'value'],
})
export class CdsDropdownItem {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsEmptyState extends Components.CdsEmptyState {}

@ProxyCmp({
  defineCustomElementFn: undefined,
})
@Component({
  selector: 'cds-empty-state',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
})
export class CdsEmptyState {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsEvidence extends Components.CdsEvidence {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['bottomText', 'topText', 'urlFile'],
})
@Component({
  selector: 'cds-evidence',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['bottomText', 'topText', 'urlFile'],
})
export class CdsEvidence {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsFileUpload extends Components.CdsFileUpload {
  /**
   * Triggers when a file is added or removed.
   */
  cdsFileChanged: EventEmitter<CustomEvent<{ hasError: boolean; filesWithoutError: Array<File> }>>;
}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['accept', 'disabled', 'maxBundleSize', 'maxFileSize', 'maxFiles', 'multiple'],
  methods: ['clear'],
})
@Component({
  selector: 'cds-file-upload',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['accept', 'disabled', 'maxBundleSize', 'maxFileSize', 'maxFiles', 'multiple'],
  outputs: ['cdsFileChanged'],
})
export class CdsFileUpload {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsFileChanged']);
  }
}

export declare interface CdsIcon extends Components.CdsIcon {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['name', 'color'],
})
@Component({
  selector: 'cds-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['name', 'color'],
})
export class CdsIcon {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsInfoBar extends Components.CdsInfoBar {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['withCloseButton', 'type'],
})
@Component({
  selector: 'cds-info-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['withCloseButton', 'type'],
})
export class CdsInfoBar {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

import type { InputChangeEventDetail as IInputInputChangeEventDetail } from '@cds.js/core/dist/types/components/input/input-event.interface';
export declare interface CdsInput extends Components.CdsInput {
  /**
   * Emitted when a keyboard input occurred.
   */
  cdsInput: EventEmitter<CustomEvent<IInputInputChangeEventDetail>>;
  /**
   * Emitted when the value has changed.
   */
  cdsChange: EventEmitter<CustomEvent<IInputInputChangeEventDetail>>;
  /**
   * Emitted when the input loses focus.
   */
  cdsBlur: EventEmitter<CustomEvent<FocusEvent>>;
  /**
   * Emitted when the input has focus.
   */
  cdsFocus: EventEmitter<CustomEvent<FocusEvent>>;
}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: [
    'clearable',
    'disabled',
    'endIcon',
    'label',
    'max',
    'maxlength',
    'min',
    'minlength',
    'name',
    'pattern',
    'placeholder',
    'readonly',
    'required',
    'size',
    'startIcon',
    'togglePassword',
    'type',
    'value',
    'helperText',
  ],
})
@Component({
  selector: 'cds-input',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: [
    'clearable',
    'disabled',
    'endIcon',
    'label',
    'max',
    'maxlength',
    'min',
    'minlength',
    'name',
    'pattern',
    'placeholder',
    'readonly',
    'required',
    'size',
    'startIcon',
    'togglePassword',
    'type',
    'value',
    'helperText',
  ],
  outputs: ['cdsInput', 'cdsChange', 'cdsBlur', 'cdsFocus'],
})
export class CdsInput {
  protected el: HTMLElement;

  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsInput', 'cdsChange', 'cdsBlur', 'cdsFocus']);
  }
}

export declare interface CdsControlError extends Components.CdsControlError {}

@ProxyCmp({
  defineCustomElementFn: undefined,
})
@Component({
  selector: 'cds-control-error',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
})
export class CdsControlError {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsLink extends Components.CdsLink {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['align', 'disabled', 'endIcon', 'href', 'startIcon', 'target', 'type'],
})
@Component({
  selector: 'cds-link',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['align', 'disabled', 'endIcon', 'href', 'startIcon', 'target', 'type'],
})
export class CdsLink {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsLoading extends Components.CdsLoading {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['message', 'type'],
  methods: ['close'],
})
@Component({
  selector: 'cds-loading',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['message', 'type'],
})
export class CdsLoading {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsLottiePlayer extends Components.CdsLottiePlayer {
  /**
   * Error if lottie failed
   */
  cdsErrorLoad: EventEmitter<CustomEvent<any>>;
}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['autoplay', 'background', 'currentState', 'hover', 'loop', 'speed', 'src'],
  methods: [
    'play',
    'pause',
    'stop',
    'getLottie',
    'setSpeed',
    'setLooping',
    'togglePlay',
    'toggleLooping',
  ],
})
@Component({
  selector: 'cds-lottie-player',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['autoplay', 'background', 'currentState', 'hover', 'loop', 'speed', 'src'],
  outputs: ['cdsErrorLoad'],
})
export class CdsLottiePlayer {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsErrorLoad']);
  }
}

export declare interface CdsMenu extends Components.CdsMenu {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['disabled', 'icon'],
  methods: ['open', 'hide'],
})
@Component({
  selector: 'cds-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['disabled', 'icon'],
})
export class CdsMenu {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsMenuItem extends Components.CdsMenuItem {
  /**
   *  @Internal undefined
   */
  cdsMenuItem: EventEmitter<CustomEvent<void>>;
}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['disabled', 'href', 'icon', 'target'],
})
@Component({
  selector: 'cds-menu-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['disabled', 'href', 'icon', 'target'],
  outputs: ['cdsMenuItem'],
})
export class CdsMenuItem {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsMenuItem']);
  }
}

export declare interface CdsModal extends Components.CdsModal {
  /**
   * Triggers when the user close the modal
   */
  cdsClose: EventEmitter<CustomEvent<void>>;
}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['preventClose', 'size', 'xsFull'],
})
@Component({
  selector: 'cds-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['preventClose', 'size', 'xsFull'],
  outputs: ['cdsModalClose'],
})
export class CdsModal {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsModalClose']);
  }
}

export declare interface CdsModalBody extends Components.CdsModalBody {}

@ProxyCmp({
  defineCustomElementFn: undefined,
})
@Component({
  selector: 'cds-modal-body',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
})
export class CdsModalBody {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsModalFooter extends Components.CdsModalFooter {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['align'],
})
@Component({
  selector: 'cds-modal-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['align'],
})
export class CdsModalFooter {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsModalHeader extends Components.CdsModalHeader {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['withCloseButton', 'variant', 'icon'],
})
@Component({
  selector: 'cds-modal-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['withCloseButton', 'variant', 'icon'],
})
export class CdsModalHeader {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsOverlay extends Components.CdsOverlay {
  /**
   * Fired when el overlay disappears
   */
  cdsClose: EventEmitter<CustomEvent<void>>;
}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['preventClose'],
})
@Component({
  selector: 'cds-overlay',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['preventClose'],
  outputs: ['cdsOverlayClose'],
})
export class CdsOverlay {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsOverlayClose']);
  }
}

export declare interface CdsProgressBar extends Components.CdsProgressBar {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['buffer', 'color', 'mode', 'progress'],
})
@Component({
  selector: 'cds-progress-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['buffer', 'color', 'mode', 'progress'],
})
export class CdsProgressBar {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsRadio extends Components.CdsRadio {
  /**
   * Emitted when the value has changed.
   */
  cdsChange: EventEmitter<CustomEvent<string>>;
}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['checked', 'disabled', 'label', 'name', 'value', 'variant'],
})
@Component({
  selector: 'cds-radio',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['checked', 'disabled', 'label', 'name', 'value', 'variant'],
  outputs: ['cdsChange'],
})
export class CdsRadio {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsChange']);
  }
}

export declare interface CdsTab extends Components.CdsTab {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['active', 'disabled', 'label'],
})
@Component({
  selector: 'cds-tab',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['active', 'disabled', 'label'],
})
export class CdsTab {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsTabGroup extends Components.CdsTabGroup {
  /**
   * Event for select a tab
   */
  cdsChange: EventEmitter<CustomEvent<number>>;
}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['selectedIndex', 'tabsAlign'],
})
@Component({
  selector: 'cds-tab-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['selectedIndex', 'tabsAlign'],
  outputs: ['cdsChange'],
})
export class CdsTabGroup {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsChange']);
  }
}

import type { TextareaChangeEventDetail as ITextareaTextareaChangeEventDetail } from '@cds.js/core/dist/types/components/textarea/textarea-event.interface';
export declare interface CdsTextarea extends Components.CdsTextarea {
  /**
   * Emitted when a keyboard input occurred.
   */
  cdsInput: EventEmitter<CustomEvent<ITextareaTextareaChangeEventDetail>>;
  /**
   * Emitted when the value has changed.
   */
  cdsChange: EventEmitter<CustomEvent<ITextareaTextareaChangeEventDetail>>;
  /**
   * Emitted when the input loses focus.
   */
  cdsBlur: EventEmitter<CustomEvent<FocusEvent>>;
  /**
   * Emitted when the input has focus.
   */
  cdsFocus: EventEmitter<CustomEvent<FocusEvent>>;
}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: [
    'disabled',
    'label',
    'maxlength',
    'minlength',
    'name',
    'placeholder',
    'readonly',
    'rows',
    'value',
    'helperText',
  ],
})
@Component({
  selector: 'cds-textarea',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: [
    'disabled',
    'label',
    'maxlength',
    'minlength',
    'name',
    'placeholder',
    'readonly',
    'rows',
    'value',
    'helperText',
  ],
  outputs: ['cdsInput', 'cdsChange', 'cdsBlur'],
})
export class CdsTextarea {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsInput', 'cdsChange', 'cdsBlur']);
  }
}

export declare interface CdsTimeline extends Components.CdsTimeline {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['color', 'layout', 'size'],
})
@Component({
  selector: 'cds-timeline',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['color', 'layout', 'size'],
})
export class CdsTimeline {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsTimelineItem extends Components.CdsTimelineItem {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['circleText', 'icon', 'color', 'light', 'size'],
})
@Component({
  selector: 'cds-timeline-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['circleText', 'icon', 'color', 'light', 'size'],
})
export class CdsTimelineItem {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsToast extends Components.CdsToast {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['position'],
})
@Component({
  selector: 'cds-toast',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['position'],
})
export class CdsToast {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsToastItem extends Components.CdsToastItem {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: [
    'hasDescription',
    'hasTitle',
    'progress',
    'text',
    'textDescription',
    'timer',
    'toastTitle',
    'type',
  ],
})
@Component({
  selector: 'cds-toast-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: [
    'hasDescription',
    'hasTitle',
    'progress',
    'text',
    'textDescription',
    'timer',
    'toastTitle',
    'type',
  ],
})
export class CdsToastItem {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

import type { ToggleEvent as IToggleToggleEvent } from '@cds.js/core/dist/types/components/toggle/toggle-event.interface';
export declare interface CdsToggle extends Components.CdsToggle {
  /**
   * Emitted when the toggle is on/off
   */
  cdsChange: EventEmitter<CustomEvent<IToggleToggleEvent>>;
}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['checked', 'disabled', 'label', 'labelPosition', 'value'],
})
@Component({
  selector: 'cds-toggle',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['checked', 'disabled', 'label', 'labelPosition', 'value'],
  outputs: ['cdsChange'],
})
export class CdsToggle {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsChange']);
  }
}
export declare interface CdsBreadcrumbs extends Components.CdsBreadcrumbs {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: [],
})
@Component({
  selector: 'cds-breadcrumbs',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: [],
})
export class CdsBreadcrumbs {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsBreadcrumbItem extends Components.CdsBreadcrumbItem {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['href', 'icon', 'label', 'separator', 'target'],
})
@Component({
  selector: 'cds-breadcrumb-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['href', 'icon', 'label', 'separator', 'target'],
})
export class CdsBreadcrumbItem {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}
export declare interface CdsDatepicker extends Components.CdsDatepicker {
  /**
   * Emitted when dates changes
   */
  cdsChange: EventEmitter<CustomEvent<Array<number>>>;
}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: [
    'defaultDate',
    'disabled',
    'label',
    'maxDate',
    'minDate',
    'mode',
    'placeholder',
    'withDefaultDate',
    'maxDatesToSelect',
  ],
})
@Component({
  selector: 'cds-datepicker',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: [
    'defaultDate',
    'disabled',
    'label',
    'maxDate',
    'minDate',
    'mode',
    'placeholder',
    'withDefaultDate',
    'maxDatesToSelect',
  ],
  outputs: ['cdsChange'],
})
export class CdsDatepicker {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsChange']);
  }
}

export declare interface CdsPagination extends Components.CdsPagination {
  /**
   * Triggers when a page change happens
   */
  cdsPageChange: EventEmitter<CustomEvent<number>>;
}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['currentPage', 'disabled', 'totalPages'],
  methods: ['goToFirst', 'goToLast', 'next', 'previous'],
})
@Component({
  selector: 'cds-pagination',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['currentPage', 'disabled', 'totalPages'],
  outputs: ['cdsPageChange'],
})
export class CdsPagination {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsPageChange']);
  }
}

export declare interface CdsButtonCopy extends Components.CdsButtonCopy {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: [
    'textToCopy',
    'toastTitleSuccess',
    'toastTextSuccess',
    'toastTitleError',
    'toastTextError',
  ],
})
@Component({
  selector: 'cds-button-copy',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: [
    'textToCopy',
    'toastTitleSuccess',
    'toastTextSuccess',
    'toastTitleError',
    'toastTextError',
  ],
})
export class CdsButtonCopy {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsCookieConsentBanner extends Components.CdsCookieConsentBanner {}

@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['cookieUrl', 'btnAcceptText'],
})
@Component({
  selector: 'cds-cookie-consent-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['cookieUrl', 'btnAcceptText'],
})
export class CdsCookieConsentBanner {
  protected el: HTMLElement;
  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
  }
}

export declare interface CdsSignaturePad extends Components.CdsSignaturePad {
  /**
   * Fired when user save the signature
   */
  cdsSaveSignature: EventEmitter<CustomEvent<File>>;
}
@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['fileName', 'clearButtonText', 'saveButtonText'],
})
@Component({
  selector: 'cds-signature-pad',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['fileName', 'clearButtonText', 'saveButtonText'],
  outputs: ['cdsSaveSignature'],
})
export class CdsSignaturePad {
  protected el: HTMLElement;

  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsSaveSignature']);
  }
}

export declare interface CdsRefreshButton extends Components.CdsRefreshButton {
  /**
   * Triggered when user clicks in the button
   */
  cdsRefresh: EventEmitter<CustomEvent<void>>;
}
@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['lastUpdate', 'text'],
})
@Component({
  selector: 'cds-refresh-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['lastUpdate', 'text'],
  outputs: ['cdsRefresh'],
})
export class CdsRefreshButton {
  protected el: HTMLElement;

  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsRefresh']);
  }
}

export declare interface CdsTooltip extends Components.CdsTooltip {
  /**
   * Emitted isOpen as `true` and tooltip ID when show tooltip and isOpen as `false`.
   */
  cdsTooltipShow: EventEmitter<
    CustomEvent<{
      id: string;
      isOpen: boolean;
    }>
  >;
}
@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['text', 'position', 'opened', 'triggerOnClick'],
})
@Component({
  selector: 'cds-tooltip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['text', 'position', 'opened', 'triggerOnClick'],
  outputs: ['cdsTooltipShow'],
})
export class CdsTooltip {
  protected el: HTMLElement;

  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsTooltipShow']);
  }
}

export declare interface CdsOffline extends Components.CdsOffline {
  /**
   * Triggers when network status change
   */
  cdsNetworkStatusChange: EventEmitter<
    CustomEvent<{
      isOnline: boolean;
    }>
  >;
}
@ProxyCmp({
  defineCustomElementFn: undefined,
  inputs: ['alertTitle', 'alertMessage'],
})
@Component({
  selector: 'cds-offline',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['alertTitle', 'alertMessage'],
  outputs: ['cdsNetworkStatusChange'],
})
export class CdsOffline {
  protected el: HTMLElement;

  constructor(
    c: ChangeDetectorRef,
    r: ElementRef,
    protected z: NgZone
  ) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['cdsNetworkStatusChange']);
  }
}
